document.addEventListener('DOMContentLoaded', function () {
  const promoIcons = document.querySelectorAll('.popup-trigger-icon');
  let emailSubmitted = false;

  function hidePromoIcons() {
    promoIcons.forEach(icon => {
      icon.style.display = 'none';
      icon.removeAttribute('href');
      icon.style.pointerEvents = 'none';
    });
    document.cookie = "promo_dismissed=true; path=/; max-age=" + 60*60*24*30;
  }

  function observeOptiModalClose() {
    const selector = '.om-outer-modal, .om-inner-modal';
    const observer = new MutationObserver((mutations, obs) => {
      if (!document.querySelector(selector)) {
        hidePromoIcons();
        obs.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // 1. Already dismissed?
  if (document.cookie.includes('promo_dismissed=true')) {
    hidePromoIcons();
    return;
  }

  // 2. Klaviyo form submit
  window.addEventListener('klaviyoForms', function (e) {
    if (e.detail?.type === 'submit') {
      emailSubmitted = true;
      const observer = new MutationObserver(() => {
        if (!document.querySelector('.klaviyo-form') && emailSubmitted) {
          hidePromoIcons();
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  });

  // 3. OptiMonk via dataLayer
  window.dataLayer = window.dataLayer || [];
  (function(){
    const originalPush = window.dataLayer.push;
    window.dataLayer.push = function(){
      Array.from(arguments).forEach(evt => {
        if (evt.event === 'optimonk_campaign_event' && evt.action === 'conversion') {
          hidePromoIcons();
          observeOptiModalClose();
        }
      });
      return originalPush.apply(this, arguments);
    };
  })();

  // 4. Prevent scroll jumps when clicking the icon
  document.querySelectorAll('a.popup-trigger-icon').forEach(el => {
    el.addEventListener('click', e => e.preventDefault());
  });
});
